<div class="main">
    <div class="loader" *ngIf="showLoader">
        <div class="load">
          <mat-spinner></mat-spinner>
        </div>
      </div>
        <div class="section">
            <div class="header">
                {{'ATTACHVEHICLE.attachVehicle' | translate}}
                <i class="material-icons" (click)="closeDialog();">
                    clear
                </i>
            </div>
            <div class="table">
                <table mat-table *ngIf="vehicles.length;else noVehicles" [dataSource]="vehicles">
                    <ng-container matColumnDef="vehicleType">
                        <th mat-header-cell *matHeaderCellDef> 
                            <div class="input">
                                <div class="inputSelect">
                                    <mat-select (closed)="searchFilter(filters.vehicleType, 'type')" multiple [placeholder]="'VEHICLE.vehicleType' | translate" [(ngModel)]="filters.vehicleType">
                                      <mat-option *ngFor="let vehicle of allVehicles" (onSelectionChange)="selectVehicleType(vehicle, $event)" [value]="vehicle._id">
                                        {{vehicle.name}}
                                      </mat-option>
                                    </mat-select>
                                  </div>
                            </div>    
                        </th>
                        <td mat-cell *matCellDef="let row"> <img *ngIf="row.attached.length" style="width: 20px;" src="assets/atach-driver.svg" alt=""> {{row.vehicleType}} </td>
                    </ng-container>
                    <ng-container matColumnDef="number">
                        <th mat-header-cell *matHeaderCellDef> 
                            <div class="input">
                                    <i class="material-icons search">
                                            search
                                            </i>
                                <input type="text" [placeholder]="'ATTACHVEHICLE.vehicleNumber' | translate" (keyup)="searchFilter(filters.vehicleNumber, 'number')" [(ngModel)]="filters.vehicleNumber">
                            </div>    
                        </th>
                        <td mat-cell *matCellDef="let row"> {{row.number}} </td>
                    </ng-container>
                    <!-- <ng-container  matColumnDef="bodyType">
                        <th mat-header-cell *matHeaderCellDef> Body Type </th>
                        <td mat-cell *matCellDef="let row"> {{row.bodyType}} </td>
                    </ng-container> -->
                    
                    <ng-container matColumnDef="regYear">
                            <th mat-header-cell *matHeaderCellDef>{{'ATTACHVEHICLE.regYear' | translate}}</th>
                            <td mat-cell *matCellDef="let row"> {{row.regYear}} </td>
                        </ng-container>
                    <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef> {{'ATTACHVEHICLE.action' | translate}} </th>
                            <td mat-cell *matCellDef="let row"> 
                                <div class="submitButton" (click)="attach(row)">
                                    <div class="button">
                                        {{'ATTACHVEHICLE.attach' | translate}}
                                    </div>
                                </div>
                            </td>
                        </ng-container>
                    <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true;"></tr>
                    <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
                </table>
            <mat-paginator [length]="(vehicles)? totalVehicles: 0" [pageSizeOptions]="[10,25,50,100]" showFirstLastButtons (page)="pageNavigate($event)"></mat-paginator>

            </div>
            <ng-template #noVehicles>
                <div class="noVehicles" style="padding-top: 30px;">
                    {{'ATTACHVEHICLE.noVehiclesFound' | translate}}
                </div>
              </ng-template>
        </div>
    </div>